export const customFieldTypes = {
  machines: "machines",
  facilities: "facilities",
  ticket: "tickets",
  supportTicket: "supportTickets",
  knowledgeBase: "knowledgeBase",
  parts: "parts",
  contacts: "contacts",
};

export const customFieldWorkOrderScopes = {
  machines: "machines",
  facilities: "facilities",
  ticket: "tickets",
};

export const fieldType = {
  date: "date",
  singleSelect: "singleSelect",
  multiSelect: "multiSelect",
  text: "text",
  number: "number",
  address: "address",
};
